exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-striped tbody tr:nth-of-type(odd){background-color:#f8f9fa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./src/assets/styles/table-style.css
// module id = 504
// module chunks = 38